// Helper function to get a comparable numeric value for sorting by delivery days
export const getComparableDayValue = (days) => {
  if (typeof days === 'number') {
    return days;
  }
  if (typeof days === 'string') {
    if (days.includes('-')) {
      return parseInt(days.split('-')[0], 10); // Use the lower bound for "fastest"
    }
    const parsed = parseInt(days, 10);
    return isNaN(parsed) ? Infinity : parsed; // Return Infinity if not parsable, so it's not considered fastest
  }
  return Infinity; // Default for unknown types
}; 